<template>
  <div>
    <div class="cyc-dialog" v-if="isshow">
        <p>{{msg}}</p>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            isshow:false,
            ismark:true,
            msg:"我是h5提示框"
        }
    },
	methods:{
		  showFu(obj){
        this.msg = obj.msg?obj.msg:this.msg;
        obj.time = obj.time?obj.time:1500;
        this.isshow = true;
        setTimeout(()=>{
           this.isshow = false;
        },obj.time);
      },
	},
}
</script>

<style scoped lang="less">
.cyc-dialog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
}
.cycdialogs {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.cyc-dialog p {
  padding: 0.25rem 0.4rem;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 0.28rem;
  border-radius: 0.06rem;
}
</style>



// WEBPACK FOOTER //
// src/components/apph5ui/toast.vue